const days = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

export function getWeekDayDe() {
  return days[new Date().getDay()];
}
